class QCTest {
  constructor() {
    if (this.isEligible()) {
      const flag = Signalman.featureFlag('qq_form');
      const qcFormSelector = '.pc-QuoteControl';

      if (flag === 'test') {
        $(qcFormSelector).css({display: 'flex'});
      } else {
        $(qcFormSelector).css({display: 'none'});
      }
    }
  }

  isEligible() {
    if (!ProductCatalog.IFrame.isFramed() || !$('.pc-Styles').length) {
      return false;
    }
    return true;
  }
}

ProductCatalog.QCTest = new QCTest();
